import request from '@/utils/request'

/**
 * 欠费减免 申请/审核 相关接口
 * serviceCode 对应后端 fee.applyFeeDeduction / fee.listFeeDeductionApply / fee.auditFeeDeduction / fee.cancelFeeDeductionApply
 */

/**
 * 提交欠费减免申请
 * @param {Object} data - { communityId, feeId, deductionAmount, message, applyUserName? }
 */
export function applyFeeDeduction(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.applyFeeDeduction',
      method: 'post',
      data
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询欠费减免申请列表
 * @param {Object} params - { communityId, page, row, state?, feeId?, payerObjId?, applyUserId? }
 */
export function listFeeDeductionApply(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.listFeeDeductionApply',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data || response)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核欠费减免申请（通过/驳回）
 * @param {Object} data - { communityId, auditId, state(1200通过/1300驳回), message? }
 */
export function auditFeeDeduction(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.auditFeeDeduction',
      method: 'post',
      data
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 撤回欠费减免申请
 * @param {Object} data - { communityId, auditId }
 */
export function cancelFeeDeductionApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.cancelFeeDeductionApply',
      method: 'post',
      data
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}
